import YouDidItImage from '../Images/youdidit.webp'
import RedXImage from '../Images/redx.svg';
import GreenCheckImage from '../Images/greencheck.svg';
import React from 'react'
import { API_URL } from '../Constants'
import { SectionBase, DifficultyBadge, Time, NextQuestion } from '../Shared/SectionBase'
import { Link } from 'react-router-dom'
import Menu from '../Shared/Menu';
import TargetRadio from '../Shared/TargetRadio';
import { isNullOrUndefinedOrWhitespace } from '../Utils';
import Listening from '../Shared/Listening'
import Writer from '../Shared/Writer'
export default class InteractiveListening extends SectionBase {

    constructor(props) {
        super(props)
        this.nextConversationPart = this.nextConversationPart.bind(this)
        this.nextQuestion = this.nextQuestion.bind(this);
        this.onSummaryInput = this.onSummaryInput.bind(this)
        this.onDifficultyChange = this.onDifficultyChange.bind(this);
        this.retry = this.retry.bind(this);
        this.setAnswer = this.setAnswer.bind(this)
        this.submit = this.submit.bind(this)
    }

    TEST_TIME_SECONDS = 210

    state = {
        difficulty: 1
    }

   

    async nextQuestion() {
        console.log('nextQ');
        const secondsLeft = this.TEST_TIME_SECONDS;
        const step = 1;
        const conversationStep = 1;
        const answer = undefined;
        const { difficulty } = this.state;
        const { token } = this.props;

        const res = await fetch(`${API_URL}/interactivelistening/createquestion/${difficulty}`,
            { headers: { Authorization: `Token ${token}` } });
        try {
            const result = await res.json();
            const interactivelistening_id = result[0].id;
            const conversationparts = this.prepareParts(result[0].conversationparts, true);
            const {example_summary} = result[0];
            //move first conversation text to title
            const title = conversationparts[0].text || result[0].title;
            conversationparts[0].text = null;

            this.setState({ title,example_summary, interactivelistening_id, conversationparts, secondsLeft, step, conversationStep, answer }, this.restartTimer);

        } catch (e) {
            console.log(e);
            console.log(res);
        }
    }

    getConversationPartAlts(p) {
        return [...p.alts, p.correct_answer].sort(() => (Math.random() > 0.5) ? 1 : -1)
    }

    nextConversationPart() {
        const { conversationStep, conversationparts } = this.state;
        if (conversationStep === conversationparts.length) {
            this.setState({ step: 2 })
        }
        this.setState({ conversationStep: conversationStep + 1 });
    }

    onSummaryInput(e){
        this.setState({summary:e.target.value})
    }

    onTimeIsUp() {
        const { conversationparts } = this.state;
       
        this.setState({ conversationStep:conversationparts.length,step: 2 }) //TODO check this
    }



    onDifficultyChange(e) {
        this.setState({ difficulty: e.target.value }, this.nextQuestion);

    }

    prepareParts(parts) {
        for (var i = 0; i < parts.length; i++) {
            const p = parts[i];
            p.answer = undefined;
            if (p.alts !== undefined) {
                p.preparedAlts = this.getConversationPartAlts(p);
            }
        }
        return parts;
    }



    render() {
        const { token } = this.props;



        const {profile, conversationparts, secondsLeft, step, summary, conversationStep, difficulty, title, example_summary } = this.state;

        const getConversationPartClass = (p, showCorrect) => {
            const { answer, correct_answer } = p;
            return showCorrect ? (answer === correct_answer ? 'alert alert-success text-success' : 'alert alert-danger text-danger') : 'alert bg-light';
        }

        const getConversationPartImage = (p, showCorrect) => {
            const { answer, correct_answer } = p;
            return showCorrect ? (answer === correct_answer ? GreenCheckImage : RedXImage) : null; 
        }

        let currentStepTitle = title;

        if (step>=3) currentStepTitle = 'Summarize the conversation';



        return (
            <>
                {token !== null && conversationparts && <div className={`interactivelistening`}>
                    <Menu token={token}  profile={profile} onDifficultyChange={this.onDifficultyChange}></Menu>
                    <Time seconds={secondsLeft}></Time>
                    <DifficultyBadge difficulty={difficulty}></DifficultyBadge>
                    <div className='px-5' >
                        <h1 className='text-center'>{currentStepTitle}</h1>
                        { step <3 && <div className='parts my-5'>{conversationparts.slice(0, conversationStep).map((p, partInd) => {
                            //TODO Check or Wrong mark on the bubble
                            const showCorrect = conversationStep > partInd + 1;
                            p.elementKey = `part-${partInd}`;
                            const icon = getConversationPartImage(p, showCorrect);
                            const partClass = getConversationPartClass(p,showCorrect);
                            const isCorrect = p.correct_answer === p.answer;
                            const question = (p.file === null) ? p.text : <Listening file={p.file} listensremaining={null} ></Listening>
                            return <>
                                {question && <div className='conversation-question-wrap d-flex flex-row'>
                                <div className='conversation-question alert bg-light'>
                                    {question}
                                </div>
                                </div>}
                                <div className='conversation-answer-wrap d-flex flex-row-reverse '> <div className={`conversation-answer ${partClass}`}>
                                    {icon && <img src={icon} alt={partClass}/>}
                                    {showCorrect ? <div>{isCorrect ? '' : <><p><s>{p.answer}</s></p><p className='m-0'>Correct Answer:</p></>}{p.correct_answer}</div>
                                        :
                                        <div><TargetRadio options={p.preparedAlts} showCorrect={false} key={p.elementKey} correctAnswer={p.correct_answer} answer={p.answer} onChange={(e) => { this.setAnswer(partInd, e.target.value) }}></TargetRadio>
                                            <div className='text-center'><button type="button" className={`btn btn-dark rounded-pill`} onClick={this.nextConversationPart}>NEXT</button></div>
                                        </div>
                                    }
                                </div></div>



                            </>

                        })}
                        </div>
                        }
                        {step===3 && <div>
                            
                            <Writer answer={summary} onInput={this.onSummaryInput}></Writer>
          

                        </div>}

                        {step===4 && <div>
                            <div className='custom-box-1 shadow-lg text-center m-auto p-4 my-5' style={{maxWidth:'500px'}}>
                                            <h4>Your Summary</h4>
                                            <p className='text-start'>
                                            {summary}
                                            </p>
                                            <hr />
                                            <h4>Example Summary</h4>
                                            <p className='text-start'>
                                            {example_summary}
                                            </p>

                            </div>
                        </div>}






                        <div className={`buttons d-flex ${(step === 2) ? 'justify-content-center':'justify-content-between'}`}>
                        {step !== 2 && <button type="button" className={`btn btn-dark rounded-pill`} onClick={this.retry}>RETRY</button>}

                            {step === 2 && <div className='text-center'>
                                <div className='mb-2'>
                                    <img width="500" height="375" alt="shark character" style={{filter:'grayscale(1)'}} src={YouDidItImage} />
                    
                                </div>
                                <button type="button" className={`btn btn-dark rounded-pill`} onClick={()=>this.setState({step:3})}>SUMMARIZE</button>
                                </div>
                            }

                            {step === 3 && <button type="button" className={`btn btn-dark rounded-pill`} onClick={this.submit}>SUBMIT</button>}
                            
                        </div>
                        <NextQuestion nextQuestion={this.nextQuestion}></NextQuestion>
                        {false && <div>{JSON.stringify(this.state)}</div>}
                    </div>

                </div>}

                {token === null && <div className='p-5'>Please <Link to="/home/">login</Link> and refresh this page</div>}

            </>

        )
    }


    retry() {
        const conversationparts = this.prepareParts([...this.state.conversationparts]);
        this.setState({ conversationparts, conversationStep: 1, step: 1, answer: undefined, secondsLeft: this.TEST_TIME_SECONDS });
        this.restartTimer();
    }

    setAnswer(partInd, value) {

        const conversationparts = [...this.state.conversationparts];
        conversationparts[partInd].answer = value;
        this.setState({ conversationparts });

    }

    async submit() {
        const { summary, interactivelistening_id } = this.state;
       
        const res = await fetch(`${API_URL}/interactivelistening/submittedanswer`, {
          method: 'POST',
          body: JSON.stringify({summary, interactivelistening:interactivelistening_id}),
          headers: { Authorization: `Token ${this.props.token}`,"Content-Type": "application/json" } 
        });
        const data = await res.json();
    
        console.log(data);
        
        this.stopTimer();
        this.setState({ step: 4 });

    }

    setWordFocus(i) {

        const { parts } = this.state;
        for (var j = 0; j < parts.length; j++) {
            parts[j].is_focus = j === i ? true : false;
        }
        this.setState({ parts });
    }
}
